import { Consumer as LocaleConsumer } from '@active/react-utils/i18n/LocaleContext'
import connect from '@active/react-utils/hoc/connect'

const connectLocale = connect(LocaleConsumer)
export default connectLocale
